export default {
  common: {
    clearAll: 'Clear ALL',
    required: '必須',
    restart: '再起動'
  },
  createUser: {
    acceptTermsAndConditions: '利用規約に同意する',
    alreadyHaveAccount: 'アカウントをお持ちですか？%{pre}ダウンロード%{post}',
    checkEmail: 'それまでの間、Metrica Playをパソコンにダウンロードする',
    clubCompany: '組織/クラブ',
    createdSuccessfully:
      '登録が成功しました！登録したメールアドレスで確認リンクを確認してください。(迷惑メールフォルダもご確認ください。)',
    email: 'メールアドレス',
    invalidEmail: '無効なメールアドレス',
    job: '職種/役割',
    lastName: '姓',
    name: '名',
    noCustomOption: 'オプションはありません',
    noMatches: '一致するものがない、自分でオプションを書き込む',
    password: 'パスワード',
    passwordsDontMatch: 'パスワードが一致しません',
    passwordInvalid: 'パスワードが要件を満たしていません',
    passwordRequirements: {
      minLength: '%{count}文字以上',
      uppercase: '大文字を1文字',
      lowercase: '小文字を1文字',
      number: '数字を1文字（0-9）',
      maxLength: '%{count}文字以下'
    },
    phone: '電話',
    phoneCode: '国',
    proceed: '進む',
    repeatPassword: 'パスワードの再発行',
    searchPhoneCode: '検索...',
    seeTermsAndConditions: '利用規約を確認',
    signAgreement:
      'Metrica Sportsのアカウントに登録することは、%{pre1}プライバシーポリシー%{post1}と%{pre2}利用規約%{post2}に同意することを意味します',
    signUpHere: 'アカウントを作成して始めましょう。',
    sport: 'スポーツ',
    submitting: '開始...',
    title: '%{product} を始めましょう',
    userKeyField: 'プロモコード・ユーザーキーをお持ちの方は、このフィールドに入力してください'
  },
  error: {
    downloadPlay:
      'すでにアカウントをお持ちの方は、最新版のPlayをダウンロードし、ログインしてください。',
    emailTaken: 'このメールはすでに削除されています',
    fieldTooLong: '一部の項目が長すぎます。短くしてもう一度お試しください',
    oops: 'おっと!',
    restart: 'あなたは現在開発中のものに入ろうとしてるようです...',
    tryAgain: 'このエラーが続く場合は、Metrica Sportsのサポートチームに連絡してください。',
    userKey:
      'キーが有効ではありません。キーを確認してもう一度試すか、フィールドを削除して登録を完了してください'
  },
  invitation: {
    acceptButton: '私のアカウント変更を受け入れます',
    accepting: '受け入れています...',
    cancelButton: '拒否',
    description1:
      '新しいMetrica Sportsアカウントに追加されると、現在のMetrica Sportsアカウント（およびその中に含まれる情報）の所有権が新しいMetrica Sportsアカウントの所有者に転送され、割り当てられます。現在、Metrica Sportsアカウントに含まれているすべての情報とデータ、およびアカウント変更を受け入れた後に保存された任意の情報やデータは、新しいMetrica Sportsアカウントの所有者とそのアカウントの管理者によって、所有者の裁量に従って他者と共有するために使用され、利用可能となります。',
    description2: '「アカウント変更を承認する」をクリックすることで、以下を承諾および認証します：',
    list1: '既存のアカウント情報は、新しいMetrica Sportsアカウントに転送されます。',
    list2:
      '現在のアカウントから新しいMetrica Sportsアカウントに転送されたすべてのアカウント情報は、新しいアカウントの所有者および/または管理者によって管理できます。',
    list3:
      '新しいMetrica Sportsのアカウントでは、あなたの役割は「メンバー」になります。現在のアカウントの所有者や管理者の権限はもう持てなくなります。',
    list4:
      '新しいMetrica Sportsアカウントの既存の設定を引き継ぎます。これは、アカウント内のあなたの役割に応じて、より制限的またはそれほど制限的ではない場合があり、設定は新しいMetrica Sportsアカウントの所有者または管理者によって管理されることがあります。',
    list5:
      '現在の設定は、参加する新しいアカウントの設定と競合する場合、変更される可能性があります。',
    list6:
      '新しいアカウントでは、現在のアカウントにあるすべての機能にアクセスできない可能性があります。',
    list7:
      'アカウントの転送を開始したら、それを元に戻すことはできません。また、アカウント情報はすべて1つのアカウントに残ります。',
    list8:
      '「I Accept My Account Change」をクリックすると、%{pre1}%{email}%{post1}のアカウントの管理メンバーになり、Metrica Sportsの%{pre2}利用規約%{post2}および%{pre3}プライバシーポリシー%{post3}に同意したことになります。',
    subtitle:
      'この新しいMetrica Sportsアカウントの招待を受け入れると、別のMetrica Sportsアカウントに追加されます。',
    title: '招待'
  },
  jobs: {
    academyDirector: 'アカデミーディレクター',
    assistantCoach: 'アシスタントコーチ',
    dataAnalyst: 'データアナリスト',
    doctor: '医師',
    formerPlayer: '元プレイヤー',
    goalkeeperCoach: 'ゴールキーパーコーチ',
    headCoach: 'コーチ',
    journalist: 'ジャーナリスト',
    other: 'その他',
    performance: 'パフォーマンス＆フィットネス',
    player: 'プレーヤー',
    scout: 'スカウト',
    sportsDirector: 'スポーツディレクター',
    student: '学生',
    videoAnalyst: 'ビデオアナリスト'
  },
  sports: {
    americanFootball: 'アメリカンフットボール',
    baseball: '野球',
    basketball: 'バスケットボール',
    fieldHockey: 'フィールドホッケー',
    football: 'サッカー',
    futsal: 'フットサル',
    gaelicFootball: 'ゲーリックフットボール',
    handball: 'ハンドボール',
    iceHockey: 'アイスホッケー',
    lacrosse: 'ラクロス',
    netball: 'ネットボール',
    other: 'その他',
    padel: 'パデル',
    rugby: 'ラグビー',
    tennis: 'テニス',
    volleyball: 'バレーボール'
  }
}
